"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.settings = void 0;
// Set global.oclif to the new object if it wasn't set before
if (!globalThis.oclif)
    globalThis.oclif = {};
exports.settings = globalThis.oclif;
